var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgUpGraph = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 52,
    height: 40,
    fill: "none",
    viewBox: "0 0 52 40",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#EEE",
    fillRule: "evenodd",
    d: "M3.918 2.75a.75.75 0 0 0-1.5 0v26.666c0 .415.336.75.75.75h26.667a.75.75 0 0 0 0-1.5H3.918V23.91l12.567-11.781 4.486 4.486a.75.75 0 0 0 1.06 0l7.5-7.5a.75.75 0 0 0-1.06-1.06l-6.97 6.97-4.47-4.47a.75.75 0 0 0-1.043-.017L3.918 21.853z",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#0A84FF",
    fillRule: "evenodd",
    d: "M38.997 10.265a1 1 0 0 1 1.358 0l8.744 8.093c.668.617.23 1.733-.679 1.733H45.96v9.746a1 1 0 0 1-1 1H33.914a1 1 0 0 1-1-1v-9.746h-1.982c-.91 0-1.347-1.116-.68-1.733z",
    clipRule: "evenodd"
  })));
};
export default SvgUpGraph;